var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services-wrap"},[(_vm.loading)?_c('Loader'):_c('div',_vm._l((_vm.servicesList),function(service){return _c('Service',{key:service.id,attrs:{"data":service}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }